import styled from "styled-components";

export const DeliveryPageWrapper = styled.div`
  margin: 2rem;
  max-width: 45vw;
  padding-bottom: 2rem;

  .header {
    margin-bottom: 1.5rem;
  }
  h2 {
    padding-left: 1.5rem;
  }

  .card {
    background: #fff;
    border-radius: 0.625rem;
    box-shadow: 4px 8px 12px 0 rgba(180, 180, 180, 0.2);
    padding: 1.5rem;
    margin-bottom: 1rem;

    h3 {
      margin: 0 0 1rem;
      font-size: 1rem;
      font-weight: 600;
      color: #24272e;
    }
  }

  .delivery-type-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .delivery-type-tab {
    padding: 0.5rem 1rem;
    border: 1px solid #e0e2e6;
    border-radius: 0.5rem;
    background: #fff;
    cursor: pointer;
    font-size: 0.875rem;

    &.active {
      border-color: #3e434e;
      background: #6b728061;
      font-weight: 600;
    }
  }

  .hint-text {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;

    a {
      color: #4f46e5;
    }
  }

  .phone-field {
    margin-bottom: 1rem;
  }

  .delivery-field-block {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .delivery-size-alert {
    margin-bottom: 0;
  }

  .field {
    margin-bottom: 1rem;

    label {
      display: block;
      font-size: 0.875rem;
      font-weight: 500;
      margin-bottom: 0.375rem;
      color: #3e434e;
    }

    .required-mark {
      color: #dc2626;
    }

    input,
    select,
    textarea {
      width: 100%;
      padding: 0.625rem 0.75rem;
      border: 1px solid #e0e2e6;
      border-radius: 0.5rem;
      font-size: 0.875rem;
      font-family: inherit;
    }

    textarea {
      resize: vertical;
      min-height: 5rem;
    }

    .order-detail-field {
      margin-bottom: 0;
    }
  }

  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  .actions {
    display: flex;
    gap: 0.75rem;
    margin-top: 1.5rem;
    flex-wrap: wrap;
  }

  .link-button {
    background:#3e434e;
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    color: #ffffff;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    transition: background 0.3s ease;
    border: none;
    margin-block: 0.5rem;
    &:hover {
      background: #24272e;
    }
  }

  .error-text {
    color: #dc2626;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }

  .detail-card {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .detail-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    padding: 0 0.25rem;
  }

  .detail-status {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }

  .detail-status-label {
    font-size: 0.75rem;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .detail-status-value {
    font-size: 1rem;
    font-weight: 600;
    color: #24272e;
  }

  .detail-status-id {
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
  }

  .detail-refresh-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    border: 1px solid #e0e2e6;
    border-radius: 0.5rem;
    background: #fff;
    color: #3e434e;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover:not(:disabled) {
      background: #f7f8f9;
      border-color: #c4c8d0;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.spinning svg {
      animation: delivery-detail-spin 0.8s linear infinite;
    }
  }

  @keyframes delivery-detail-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f0f1f3;
    cursor: pointer;

    &:hover {
      background: #f7f8f9;
    }
  }
`;
